<template>
  <v-container fluid fill-height>
    <v-layout row wrap>
      <v-flex sm12>
        <v-toolbar
          color="#eee"
          class="elevation-0 secondary--text mb-4"
          style="background: transparent" >
          <v-toolbar-title>Meus Postos</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn icon color="info" v-on="on" @click="dialogSolicitacoes = true">
                <v-icon>swap_horiz</v-icon>
              </v-btn>
            </template>
            Solicitações de Transferência
          </v-tooltip>
          <v-dialog v-model="dialog" width="400" :fullscreen="$vuetify.breakpoint.xs">
            <v-btn icon color="primary" slot="activator">
              <v-icon>add</v-icon>
            </v-btn>
            <cad-posto
              @fechar="dialog = false"
              @success="snackbarSuccess"
              @error="snackbarError"
            ></cad-posto>
          </v-dialog>
        </v-toolbar>
        <v-data-table
          hide-actions
          :hide-headers="!postos.length"
          :pagination.sync="pagination"
          :items="postos"
          :headers="postosHeader"
          class="elevation-1"
        >
          <v-alert v-slot:no-results :value="true" color="error" icon="warning">
            Desculpe, não encontramos nenhum dado!
          </v-alert>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">{{props.item.cnpj}}</td>
              <td class="text-xs-center">{{props.item.razao_social}}</td>
              <td class="text-xs-center">{{props.item.nome_fantasia}}</td>
              <td class="text-xs-right">
                <v-tooltip bottom v-if="props.item.ativo">
                <template v-slot:activator="{ on }" >
                  <v-btn v-on="on" flat @click="cadastrarRedeSocial(props.item)">
                    <v-icon>handshake</v-icon>
                  </v-btn>
                </template>
                Adicionar redes sociais
              </v-tooltip>
                <v-tooltip bottom>
                  <template  v-slot:activator="{ on }">
                    <v-btn v-on="on" flat icon @click="openTransferir(props.item)">
                      <v-icon>swap_horiz</v-icon>
                    </v-btn>
                  </template>
                  Transferir posto
                </v-tooltip>
                <v-tooltip bottom>
                  <template  v-slot:activator="{ on }">
                    <v-btn v-on="on" flat icon color="primary" @click="selecionarPosto(props.item)">
                      <v-icon>remove_red_eye</v-icon>
                    </v-btn>
                  </template>
                  Ver Detalhes
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center">
          <v-pagination v-model="pagination.page" :length="pages" circle></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogRedesSociais" v-if="dialogRedesSociais" width="500">
      <cad-redes-sociais @fechar="dialogRedesSociais = false" :posto="postoSelected"/>
    </v-dialog>
    <v-dialog lazy width="600" v-model="dialogInfoPosto" :fullscreen="$vuetify.breakpoint.xs">
      <info-posto :posto="postoSelected" @fechar="dialogInfoPosto = false"></info-posto>
    </v-dialog>
    <v-dialog lazy width="600" v-model="dialogTransferir" :fullscreen="$vuetify.breakpoint.xs">
      <transferir-posto :posto="postoSelected" @fechar="dialogTransferir = false" @resposta="openSnackbar"/>
    </v-dialog>
    <v-navigation-drawer
      temporary
      absolute
      right
      width = 350vh
      v-if="dialogSolicitacoes"
      v-model="dialogSolicitacoes"
      class="grey lighten-4"
    >
    <solicitacoes-de-transferencia v-if="dialogSolicitacoes"/>
    </v-navigation-drawer>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.active = false"
      >
        Fechar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import InfoPosto from '@/components/dialogs/DialogInfoPosto'
import CadRedesSociais from '../../components/cadastros/CadRedesSociais.vue'
import TransferirPosto from '@/components/dialogs/TransferirPosto'
import SolicitacoesDeTransferencia from '@/components/dialogs/SolicitacoesDeTransferencia'
import CadPosto from '@/components/cadastros/CadNovoPosto'

export default {
  components: { CadPosto, InfoPosto, TransferirPosto, SolicitacoesDeTransferencia, CadRedesSociais },
  data () {
    return {
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      dialogRedesSociais: false,
      dialogInfoPosto: false,
      dialogTransferir: false,
      dialogSolicitacoes: false,
      postoSelected: null,
      pagination: {
        rowsPerPage: 10
      },
      dialog: false,
      postosHeader: [
        {
          text: 'CNPJ',
          align: 'center',
          sortable: false
        },
        {
          text: 'Razão Social',
          align: 'center',
          sortable: false
        },
        {
          text: 'Nome Fantasia',
          align: 'center',
          sortable: false
        },
        {
          align: 'right',
          sortable: false
        }
      ]
    }
  },
  computed: {
    postos () {
      return this.$store.getters.postos
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  methods: {
    snackbarSuccess (text) {
      this.snackbar.color = 'info'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    snackbarError (erro) {
      this.smartLockDialog = false
      this.snackbar.color = 'error'
      this.snackbar.text = erro
      this.snackbar.active = true
    },
    cadastrarRedeSocial (posto) {
      this.postoSelected = posto
      this.dialogRedesSociais = true
    },
    selecionarPosto (posto) {
      this.postoSelected = posto
      this.dialogInfoPosto = true
    },
    openTransferir (posto) {
      this.postoSelected = posto
      this.dialogTransferir = true
    },
    openSnackbar (data) {
      this.snackbar.color = data.color
      this.snackbar.text = data.text
      this.snackbar.active = true
    }
  }
}
</script>
